import { FC, memo } from 'react';

import { MenuItem } from '~/core/shared/components/Menu';
import { useEntityControlMenuItem } from './hooks/useEntityControlMenuItem';
import { EntityControlMenuItemProps } from './types/EntityControlMenuItemProps';

const EntityControlMenuItemComponent: FC<EntityControlMenuItemProps> = ({
  control,
  documentId,
  handleSideEffects,
  onOpenConfirm,
}) => {
  const { onClick } = useEntityControlMenuItem(
    control,
    documentId,
    handleSideEffects,
    onOpenConfirm,
  );

  return (
    <MenuItem onClick={onClick} value={control.name}>
      {control.name}
    </MenuItem>
  );
};

export const EntityControlMenuItem = memo(EntityControlMenuItemComponent);
